export function creditLimitLMS(companyId) {
  return `${process.env.REACT_APP_LMS_DOMAIN_API}/customers/${companyId}/credit_status_summary`;
}

export function creditLineUrl(leadId) {
  return `${process.env.REACT_APP_API_BASE_URL}/api/v2/credit_lines/${leadId}`;
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/apiUrls.js